import { css, styled } from 'styles';
import colors from './colors';

const Title = styled.h1`
  font-size: 5.5rem;
  font-weight: ${({ theme }) => theme.fonts.boldWeight};
  flex: 1;
`;

const SubTitle = styled.h2<{ color?: string }>`
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fonts.boldWeight};
  flex: 1;

  ${({ color }) => {
    if (color) {
      return css`
        color: ${color};
      `;
    } else {
      return null;
    }
  }}
`;

const Text = styled.p`
  font-size: 1.4rem;
  font-weight: ${({ theme }) => theme.fonts.mediumWeight};
  margin-top: -0.1rem !important;

  & em {
    color: ${colors.dirtyWhite};
    display: inline;
    margin-left: 5px;
    font-style: normal;
  }
`;

export default {
  Text,
  Title,
  SubTitle,
};
